import { useApi } from "~/composables/useApi";
import type { GlobalSearchResultType } from "@asap/shared/schemas/global-search";
import type { GlobalSearchTab } from "~/utils/global-search";

const DEFAULT_TAB: GlobalSearchTab = "talent";

export const useGlobalSearch = createSharedComposable(() => {
  const selectedTab = ref<GlobalSearchTab>(DEFAULT_TAB);

  const search = ref("");

  const showGlobalSearchModal = ref(false);

  const toggleModal = useToggle(showGlobalSearchModal);

  onKeyStroke(["k", "K"], (event) => {
    if (!isPlatformModifierKeyPressed(event)) return;
    event.preventDefault();
    toggleModal();
  });

  const open = function (tab?: GlobalSearchTab) {
    if (tab) selectedTab.value = tab;

    search.value = "";

    showGlobalSearchModal.value = true;
  };

  const close = function () {
    showGlobalSearchModal.value = false;
  };

  return {
    search,
    selectedTab,
    showGlobalSearchModal,
    open,
    close,
  };
});

export const useGlobalSearchApi = function () {
  const { invoke } = useApi();

  const searchGlobally = async function (
    params: { search: string; type?: GlobalSearchResultType },
    abortController: AbortController
  ) {
    const response = await invoke({
      path: "global-search",
      method: "GET",
      query: { q: params.search, type: params.type },
      signal: abortController.signal,
    });

    if (!response.success) {
      if (isAbortError(response.error)) return;
      throw new Error(response.error.message);
    }

    return response.data;
  };

  return searchGlobally;
};
